import { StyleSheet } from "react-native";

export const bonusGamesModalStyles = StyleSheet.create({
  buttons: {
    position: "absolute",
    zIndex: 100,
    width: 32,
    height: 32,
  },
  container: {
    width: 790,
    position: "relative",
  },
});
